import React from "react"

function IconAlertInfoCircle({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="alert-info-circle"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-alert-info-circle"
      {...props}
    >
      <path
        d="M11.935 2.302c5.32 0 9.633 4.314 9.633 9.634s-4.313 9.633-9.633 9.633c-5.32 0-9.633-4.313-9.633-9.633 0-5.32 4.313-9.634 9.633-9.634zm0 1.31a8.325 8.325 0 1 0 .002 16.648 8.325 8.325 0 0 0-.002-16.649zm-.114 6.741c.445 0 .812.333.866.763l.007.11v3.904l-.004.033h.946a.655.655 0 0 1 .107 1.301l-.107.009h-3.272a.655.655 0 0 1-.107-1.3l.107-.01h1.023l-.002-.033v-3.469l-1.021.001a.655.655 0 0 1-.646-.548l-.009-.106c0-.326.237-.596.548-.646l.107-.009h1.457zm.07-2.935a1.09 1.09 0 1 1 0 2.182 1.09 1.09 0 0 1 0-2.182z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconAlertInfoCircle
